export const separateEntriesByLocale = (allSocieties) => Object.entries(Object.entries(allSocieties.map((s) => ({
  [s.country]: [s]
})).reduce((acc, el) => {
  const [country, [entry]] = Object.entries(el)[0];
  return acc[country] ? {...acc, [country]: [...acc[country], entry]} : {...acc, [country]: [entry]};
}, {})).map(([country, dataArr]) => ({
  [dataArr[0].continent]: [[country, dataArr]]
})).reduce((acc, el) => {
  const [continent, [[country, dataArr]]] = Object.entries(el)[0];
  return acc[continent] ? {...acc, [continent]: [...acc[continent], [country, dataArr]]} : {...acc, [continent]: [[country, dataArr]]};
}, {}));
export const alphabetizeByFullname = (a, b) => a.full_name > b.full_name ? 1 : -1;
export const alphabetizeNestedArr = (a, b) => a[0] > b[0] ? 1 : -1;
